import { SweetFacePagedResponse } from './sweet-face-paged-response';
import { SweetFaceTransactionDto } from './sweet-face-transaction.dto';

export class GetSweetFaceMerchantTransactionsResponseDto extends SweetFacePagedResponse<SweetFaceTransactionDto> {}